import { AxiosPromise } from "axios";
import service from "../apis/Service";
import DtoSelectSearchParamPort from "../models.machine/DtoSelectSearchParamPort";
import RESTfulResult from "../models.machine/RESTfulResult";
import UiSelectOption from "../models.machine/UiSelectOption";
import DtoPageListSearchParamPort from "../models.machine/DtoPageListSearchParamPort";
import DtoPageListParamPort from "../models.machine/DtoPageListParamPort";
import UiDrag from "../models.machine/UiDrag";
import DtoDetailParamPort from "../models.machine/DtoDetailParamPort";
import DtoFormParamPort from "../models.machine/DtoFormParamPort";
import DtoListItemParamPort_Repeat from "../models.machine/DtoListItemParamPort_Repeat";

/**
 * 港口
 * @description 自动生成的代码,请勿修改
 */
export default class ParamPortAppService {
    /**
     * 获取港口选择器
     * @param {DtoSelectSearchParamPort} [search] 搜索条件
     * @returns {AxiosPromise<RESTfulResult<UiSelectOption<string>[]>>} 选择器
     */
    static GetSelect(search?: DtoSelectSearchParamPort): AxiosPromise<RESTfulResult<UiSelectOption<string>[]>> {
        const url = `/api/ParamPort/GetSelect`;
        return service.get<RESTfulResult<UiSelectOption<string>[]>>(url, { params: search });
    }

    /**
     * 获取港口分页列表
     * @param {DtoPageListSearchParamPort} [dto] 搜索条件
     * @returns {AxiosPromise<RESTfulResult<DtoPageListParamPort>>} 分页列表
     */
    static Get(dto?: DtoPageListSearchParamPort): AxiosPromise<RESTfulResult<DtoPageListParamPort>> {
        const url = `/api/ParamPort/Get`;
        return service.get<RESTfulResult<DtoPageListParamPort>>(url, { params: dto });
    }

    /**
     * 拖曳排序
     * @param {UiDrag<string>} [dto] 传参
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static DragSort(dto?: UiDrag<string>): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/ParamPort/DragSort`;
        return service.post<RESTfulResult<any>>(url, dto);
    }

    /**
     * 获取港口详细
     * @param {string} [id] Id
     * @returns {AxiosPromise<RESTfulResult<DtoDetailParamPort>>} 详细
     */
    static GetById(id?: string): AxiosPromise<RESTfulResult<DtoDetailParamPort>> {
        const url = `/api/ParamPort/Get/${id}`;
        return service.get<RESTfulResult<DtoDetailParamPort>>(url);
    }

    /**
     * 新增/编辑港口
     * @param {DtoFormParamPort} [dto] 表单
     * @returns {AxiosPromise<RESTfulResult<any>>} Id
     */
    static Post(dto?: DtoFormParamPort): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/ParamPort/Post`;
        return service.post<RESTfulResult<any>>(url, dto);
    }

    /**
     * 获取飞鸵港口
     * @returns {AxiosPromise<RESTfulResult<UiSelectOption<string>[]>>} 
     */
    static GetFreighTowerPorts(): AxiosPromise<RESTfulResult<UiSelectOption<string>[]>> {
        const url = `/api/ParamPort/GetFreighTowerPorts`;
        return service.get<RESTfulResult<UiSelectOption<string>[]>>(url);
    }

    /**
     * 批量删除港口
     * @param {string[]} [ids] Id
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static Delete(ids?: string[]): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/ParamPort/Delete`;
        return service.delete<RESTfulResult<any>>(url, { data: ids });
    }

    /**
     * 同步
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static SyncData(): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/ParamPort/SyncData`;
        return service.post<RESTfulResult<any>>(url);
    }

    /**
     * 导出
     * @param {string} [name] 
     * @param {string[]} [ids] 
     * @returns {AxiosPromise<RESTfulResult<string>>} 
     */
    static PostExportExceByName(name?: string, ids?: string[]): AxiosPromise<RESTfulResult<string>> {
        const url = `/api/ParamPort/PostExportExce/${name}`;
        return service.post<RESTfulResult<string>>(url, ids);
    }

    /**
     * 导出导入模板
     * @returns {AxiosPromise<RESTfulResult<string>>} 
     */
    static GetExportImportTemplate(): AxiosPromise<RESTfulResult<string>> {
        const url = `/api/ParamPort/GetExportImportTemplate`;
        return service.get<RESTfulResult<string>>(url);
    }

    /**
     * 导入
     * @param {any} [file] 
     * @returns {AxiosPromise<RESTfulResult<boolean>>} 
     */
    static PostImport(file?: any): AxiosPromise<RESTfulResult<boolean>> {
        const url = `/api/ParamPort/PostImport`;
        return service.post<RESTfulResult<boolean>>(url, file);
    }

    /**
     * 获取数据，用于重复判断
     * @returns {AxiosPromise<RESTfulResult<DtoListItemParamPort_Repeat[]>>} 
     */
    static GetList(): AxiosPromise<RESTfulResult<DtoListItemParamPort_Repeat[]>> {
        const url = `/api/ParamPort/GetList`;
        return service.get<RESTfulResult<DtoListItemParamPort_Repeat[]>>(url);
    }

}
